<template>
    <div class="onboarding-orchestrator">

        <div v-if="isSetup">
            <!-- Step 1: Business Setup -->
            <first-step v-if="currentStep === 1" :show="true" :width="width" @completed="goToWelcome"
                @error="handleError" />
        </div>
        <div v-else>
            <!-- Step 2: Welcome -->
            <second-step v-if="currentStep === 1" :show="true" :width="width" @proceed="goToOrderCreate"
                @skip="finish" />

            <!-- Step 3: Order Creation -->
            <third-step v-else-if="currentStep === 2" :show="true" :width="width" @order-created="goToSuccess"
                @skip="finish" />

            <!-- Step 4: Success -->
            <fourth-step v-else-if="currentStep === 3" :show="true" :width="width" :order-data="orderData"
                @orders="finishToOrders" @create-another="goToOrderCreate" @goto-settings="goToSettings"
                @goto-dashboard="goToDashboard" @close="finish" />
        </div>
    </div>
</template>

<script>
import responsiveSize from '@/mixins/responsiveSize';
import error from '@/mixins/error';
import _ from 'lodash';

import FirstStep from './components/1-onboarding.vue';
import SecondStep from './components/2-onboarding.vue';
import ThirdStep from './components/3-onboarding.vue';
import FourthStep from './components/4-onboarding.vue';

export default {
    name: 'Onboarding',
    props: {
        isSetup: {
            type: Boolean,
            default: () => false,
        }
    },
    components: {
        FirstStep,
        SecondStep,
        ThirdStep,
        FourthStep,
    },
    mixins: [responsiveSize, error],
    data() {
        return {
            currentStep: null,
            width: '500px',
            subscription: undefined,
            errorMessage: undefined,
            orderData: {},
        };
    },
    async mounted() {
        window.addEventListener('resize', _.debounce(this.resize, 200));
    },
    destroyed() {
        this.subscription?.unsubscribe();
        window.removeEventListener('resize', _.debounce(this.resize, 200));
        document.body.classList.remove('onboarding-setup-active');
    },
    watch: {
        errorMessage: {
            deep: true,
            handler: _.debounce(async function () {
                if (this.errorMessage) {
                    await this.$toastr.e(this.errorMessage);
                    this.errorMessage = undefined;
                }
            }, 300),
        },
    },
    methods: {
        resize() {
            const percentage = this.getPercentageWidth();
            this.width = percentage === '30%' ? '500px' : percentage;
        },
        show() {
            this.currentStep = 1;
            this.resize();
            document.body.classList.add('onboarding-setup-active');
        },
        goToWelcome() {
            this.updateOnboardingCompliance({ name: 'home.index' });
            document.body.classList.remove('onboarding-setup-active');
        },
        goToOrderCreate() {
            console.log('Welcome dialog completed, proceeding to order creation dialog');
            this.currentStep = 2;
        },
        goToSuccess(orderData) {
            console.log('Order created, showing success dialog');
            this.orderData = orderData;
            this.currentStep = 3;
        },
        finishToOrders() {
            this.currentStep = null;
            document.body.classList.remove('onboarding-setup-active');
            this.updateOnboardingCompliance({ name: 'orders.index', query: { from_onboarding: 'order_success' } });
        },
        goToSettings() {
            this.currentStep = null;
            document.body.classList.remove('onboarding-setup-active');
            this.updateOnboardingCompliance({ name: 'administration.business' });
        },
        goToDashboard() {
            this.currentStep = null;
            document.body.classList.remove('onboarding-setup-active');
            this.updateOnboardingCompliance({ name: 'home.index' });
        },
        finish() {
            this.currentStep = null;
            document.body.classList.remove('onboarding-setup-active');
            this.updateOnboardingCompliance({ name: 'home.index' });
        },
        handleError(error) {
            this.errorMessage = this.getErrorMessage(error);
        },
        async updateOnboardingCompliance(route) {
            try {
                this.$toastr.s('Onboarding compliance updated successfully');
                this.$emit('on:completed', route);
            } catch (error) {
                this.errorMessage = this.getErrorMessage(error);
            }
        },
    },
};
</script>

<style>
/* When onboarding setup is active, force the Element UI modal overlay to white */
.onboarding-orchestrator>.el-dialog__wrapper {
    background-color: #ffffff !important;
    background-image: none !important;
}
</style>
